import "./css/recharge.css";
import LocalizedPrice from "./js/components/LocalizedPrice";
import VbcSelection from "./js/components/VbcSelection";

customElements.define("localized-price", LocalizedPrice);
customElements.define("vbc-selection", VbcSelection);

/**
 * Change Recharge "Return to login" URL on customer portal page
 * shown to users who don't have a subscription. Redirect back to
 * account page (/account) rather than login
 */

const returnLink = document.querySelector(
  ".recharge.page__customers__request-invite [href='/account/login']",
);
if (returnLink && window.routes.account_url) {
  returnLink.setAttribute("href", window.routes.account_url);
}
